module.exports = "../dist/img/product-card-36.d92e.jpg";